<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un fournisseur."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- Name Column -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type</th>
                        <td mat-cell *matCellDef="let element"> {{ element.type }}</td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
                        <td mat-cell *matCellDef="let element"> {{ element.date }}</td>
                    </ng-container>
                    <ng-container matColumnDef="quantite">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantité</th>
                        <td mat-cell *matCellDef="let element"> {{ element.quantite }}</td>
                    </ng-container>
                    <!-- Address Column -->
                    <ng-container matColumnDef="motif">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Motif</th>
                        <td mat-cell *matCellDef="let element"> {{ element.motif }}</td>
                    </ng-container>
                    <ng-container matColumnDef="utilisateurId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> User</th>
                        <td mat-cell *matCellDef="let element"> {{ element.utilisateurName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="produitStockId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Produit</th>
                        <td mat-cell *matCellDef="let element"> {{ element.productName }}</td>
                    </ng-container>
                    <!-- Address Column -->
                    <ng-container matColumnDef="destination">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Destination</th>
                        <td mat-cell *matCellDef="let element"> {{ element.destination }}</td>
                    </ng-container>
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Fournisseur
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
           <form [formGroup]="editForm" (ngSubmit)="updateMouvement()">
  <div class="row">
    <!-- Type de Mouvement -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Type de Mouvement</mat-label>
        <mat-select formControlName="type" required>
          <mat-option value="ENTREE">ENTRÉE</mat-option>
          <mat-option value="SORTIE">SORTIE</mat-option>
        </mat-select>
        <mat-error *ngIf="editForm.get('type')?.hasError('required')">
          Le type est obligatoire
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Date -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="pickerEdit" formControlName="date" />
        <mat-datepicker-toggle matSuffix [for]="pickerEdit"></mat-datepicker-toggle>
        <mat-datepicker #pickerEdit></mat-datepicker>
        <mat-error *ngIf="editForm.get('date')?.hasError('required')">
          La date est obligatoire
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Quantité -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Quantité</mat-label>
        <input
          matInput
          type="number"
          formControlName="quantite"
          placeholder="Ex. 50"
        />
        <mat-error *ngIf="editForm.get('quantite')?.hasError('required')">
          La quantité est obligatoire
        </mat-error>
        <mat-error *ngIf="editForm.get('quantite')?.hasError('min')">
          La quantité doit être au moins 1
        </mat-error>
      </mat-form-field>
    </div>

  <!-- Destination -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25"  appearance="fill">
        <mat-label>Destination</mat-label>
        <mat-select formControlName="destination" required (selectionChange)="onDestinationChange()">
          <mat-option value="Analyse">Analyse</mat-option>
          <mat-option value="Destruction">Destruction</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Motif si destination = Analyse -->
    <div class="col-sm-6" *ngIf="editForm.get('destination')?.value === 'Analyse'">
      <mat-form-field class="mb-25"  appearance="fill">
        <mat-label>Référence Analyse</mat-label>
        <mat-select formControlName="motif" required>
          <mat-option *ngFor="let analyse of analysesList" [value]="analyse.refAnalyse">
            {{ analyse.refAnalyse }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Motif si destination ≠ Analyse -->
    <div class="col-sm-6" *ngIf="editForm.get('destination')?.value !== 'Analyse'">
      <mat-form-field class="mb-25"  appearance="fill">
        <mat-label>Motif</mat-label>
        <input matInput formControlName="motif" placeholder="Saisir un motif" />
      </mat-form-field>
    </div>


    <!-- Produit -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Produit</mat-label>
        <mat-select formControlName="produitStockId" required>
          <mat-option *ngFor="let produit of produits" [value]="produit.id">
            {{ produit.nom }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="editForm.get('produitStockId')?.hasError('required')">
          Le produit est obligatoire
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Bouton de sauvegarde -->
    <div class="col-sm-12 text-right">
      <button type="submit" class="btn btn-success btn-sm" [disabled]="editForm.invalid">
        Sauvegarder
      </button>
    </div>
  </div>
</form>

        </mat-card-content>
    </mat-card>
</ng-template>


<ng-template #viewModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-content>
      <div class="row">
        <h5 class="px-3 fw-bold">Détails du mouvement :</h5>

        <!-- Date -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Date :</div>
          <p>{{ mouv?.date }}</p>
        </div>

        <!-- Type -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Type :</div>
          <p>{{ mouv?.type }}</p>
        </div>

        <!-- Quantité -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Quantité :</div>
          <p>{{ mouv?.quantite }}</p>
        </div>

        <!-- Destination -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Destination :</div>
          <p>{{ mouv?.destination }}</p>
        </div>

        <!-- Motif -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Motif :</div>
          <p>{{ mouv?.motif }}</p>
        </div>

        <!-- Utilisateur -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Utilisateur :</div>
          <p>{{ mouv?.utilisateurName }}</p>
        </div>

        <!-- Produit -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Produit :</div>
          <p>{{ mouv?.productName }}</p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>


<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">Nouveau Mouvement de Stock</h5>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="saveMouvement()">
        <div class="row">
          <!-- Type de Mouvement -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Type de Mouvement</mat-label>
              <mat-select formControlName="type" required>
                <mat-option value="ENTREE">ENTRÉE</mat-option>
                <mat-option value="SORTIE">SORTIE</mat-option>

              </mat-select>
              <mat-error *ngIf="form.get('type')?.hasError('required')">
                Le type est obligatoire
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Date -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Date</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="form.get('date')?.hasError('required')">
                La date est obligatoire
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Quantité -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Quantité</mat-label>
              <input matInput type="number" formControlName="quantite" placeholder="Ex. 50" />
              <mat-error *ngIf="form.get('quantite')?.hasError('required')">
                La quantité est obligatoire
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Destination -->
          <div class="col-sm-6">
            <mat-form-field appearance="fill">
              <mat-label>Destination</mat-label>
              <mat-select formControlName="destination" required>
                <mat-option value="Analyse">Analyse</mat-option>
                <mat-option value="Destruction">Destruction</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Motif (s’affiche seulement si destination == 'Analyse') -->
          <div class="col-sm-6" *ngIf="form.get('destination')?.value === 'Analyse'">
            <mat-form-field appearance="fill">
              <mat-label>Motif (Analyse)</mat-label>
              <mat-select formControlName="motif" required>
                <mat-option *ngFor="let analyse of analysesList" [value]="analyse.id">
                  {{ analyse.refAnalyse }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('motif')?.hasError('required')">
                Le motif est obligatoire
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-6" *ngIf="form.get('destination')?.value === 'Destruction'">
            <mat-form-field appearance="fill">
              <mat-label>Motif (Analyse)</mat-label>
              <input matInput formControlName="motif" placeholder="Ex. Motif de destruction" />

              <mat-error *ngIf="form.get('motif')?.hasError('required')">
                Le motif est obligatoire
              </mat-error>
            </mat-form-field>
          </div>
          <!-- Produit -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Produit</mat-label>
              <mat-select formControlName="produitStockId" required>
                <mat-option *ngFor="let produit of produits" [value]="produit.id">
                  {{ produit.nom }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('produitStockId')?.hasError('required')">
                Le produit est obligatoire
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Bouton de sauvegarde -->
        <div class="text-right mt-2">
          <button type="submit" class="btn btn-success btn-sm" [disabled]="form.invalid">
            Sauvegarder
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>



<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
